import http from '@/http'
export default {
  namespaced: true,
  state: {
    showFilterNotification: {
      STAAGECLASS: true,
      NAPRATICA: true
    }
  },
  mutations: {
    setShowFilterNotification(state, showFilterNotification) {
      state.showFilterNotification[showFilterNotification.key] = showFilterNotification.value
    }
  },
  actions: {
    async notifications({ rootState }) {
      try {
        if (rootState.auth.isLogged === true) {
          const response = await http.get('/notification')
          return response.data.data
        }
      } catch (err) {
        console.error(err)
      }
    },
    async deleteNotification({}, notificationID) {
      try {
        const response = await http.delete(`/notification/${notificationID}/delete`)
        return response.data.data
      } catch (err) {
        console.error(err)
      }
    }
  },
  getters: {
    getShowFilterNotification: state => state.showFilterNotification
  }
}
